// extracted by mini-css-extract-plugin
module.exports = {"Four":"Four_Four__SIBxm"};